import { RequestDataProvider, RequestSender, useRequestSender } from 'request-sender';
import { useTokenContext } from '../Authentication';
import { useApiConfiguration } from './ApiConfigurationContext';
import { useTimezoneService } from './timezoneService';
import { useDataProvidersContext } from '../DataProvider/DataProviderContext';

export interface BackendApiProps {
  version?: number
}

export function useBackendApi(props?: BackendApiProps): RequestSender {
  const tokenContext = useTokenContext();

  const apiConfiguration = useApiConfiguration();

  const timezoneService = useTimezoneService();

  const dataProvidersContext = useDataProvidersContext();

  const dataProviders: RequestDataProvider[] = [
    {
      getHeaders: () => tokenContext.getApiHeaders(),
    },
    {
      getHeaders: () => ({
        'X-NEKST-TIMEZONE': timezoneService.getTimezone(),
      })
    },
    ...(dataProvidersContext || []),
  ];

  return useRequestSender({
    baseUrl: apiConfiguration.backendUrl,
    dataProviders,
    version: props?.version,
  });
}
